var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const string = {
    isFalsy(str) {
        return !str
            || str === ''
            || str === undefined
            || typeof str === undefined
            || str === null
            || str === 'undefined';
    }
};
export const hasErrors = (errors) => Object.keys(errors).some(fieldName => {
    if (object.isObject(errors[fieldName])) {
        return hasErrors(errors[fieldName]);
    }
    if (errors[fieldName].length === 0) {
        return false;
    }
    for (const err of errors[fieldName]) {
        if (!Array.isArray(err)) {
            return true;
        }
        if (Array.isArray(err) && err.length > 0) {
            return true;
        }
    }
    return false;
});
export const object = {
    copy(obj) {
        return JSON.parse(JSON.stringify(obj));
    },
    cloneInstance(instance) {
        return Object.assign(Object.create(
        // Set the prototype of the new object to the prototype of the instance.
        // Used to allow new object behave like class instance.
        Object.getPrototypeOf(instance)), 
        // Prevent shallow copies of nested structures like arrays, etc
        object.copy(instance));
    },
    isObject(obj) {
        return Object.prototype.toString.call(obj) === "[object Object]";
    }
};
export const cloneValidators = (validators) => {
    return validators.reduce((clone, v) => {
        const { name, errMsg, validator } = v;
        clone.push({
            name,
            validator: object.cloneInstance(validator),
            errMsg
        });
        return clone;
    }, []);
};
export const getNestedValue = (path, allData) => {
    return path.split(".").reduce((acc, field) => {
        if (object.isObject(acc[field])) {
            acc = acc[field];
        }
        else {
            return acc[field];
        }
        return acc;
    }, allData);
};
export const shouldNotValidate = (name, value, configs, allCtxData) => __awaiter(void 0, void 0, void 0, function* () {
    return (configs.shouldValidateFields[name] && !(yield configs.shouldValidateFields[name].shouldValidate(allCtxData))) || (configs.omitEmpty[name] && !value);
});
export const handleValidation = (validatorName, validators, name, value, parsedValidationRules, allCtxData, errors, configs, index) => __awaiter(void 0, void 0, void 0, function* () {
    if (string.isFalsy(validatorName)) {
        return false;
    }
    const validatorObj = validators.find(v => v.name === validatorName);
    if (!validatorObj) {
        throw new RangeError(`Please provide existing validator name for ${name}. ${validatorName} doesn't exists!`);
    }
    const { validator, errMsg: defaultErrMsg } = validatorObj;
    const { isValid, errMsg = defaultErrMsg, additionalData = {} } = yield validator.validate(value, parsedValidationRules[name][validatorName], allCtxData);
    if (!isValid) {
        if (index !== undefined) {
            errors[name][index].push({ errMsg, additionalData });
        }
        else {
            errors[name].push({ errMsg, additionalData });
        }
        if (configs.stopOnError[name]) {
            return true;
        }
    }
    return false;
});
